"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericButton = exports.ButtonTypeAttributes = exports.ButtonSizes = exports.ButtonShapes = exports.ButtonTypes = void 0;
var react_1 = __importDefault(require("react"));
var isUndefined_1 = __importDefault(require("lodash/isUndefined"));
var Button_1 = __importDefault(require("react-bootstrap/lib/Button"));
var techsee_base_component_1 = require("../../../_shared/techsee-base-component");
require("./styles.scss");
var ButtonTypes;
(function (ButtonTypes) {
    ButtonTypes["Primary"] = "primary";
    ButtonTypes["Secondary"] = "secondary";
    ButtonTypes["Closer"] = "closer";
    ButtonTypes["Icon"] = "icon";
    ButtonTypes["Edit"] = "edit";
})(ButtonTypes = exports.ButtonTypes || (exports.ButtonTypes = {}));
var ButtonShapes;
(function (ButtonShapes) {
    ButtonShapes["Rectangle"] = "rectangle";
    ButtonShapes["Rounded"] = "rounded";
})(ButtonShapes = exports.ButtonShapes || (exports.ButtonShapes = {}));
var ButtonSizes;
(function (ButtonSizes) {
    ButtonSizes["Small"] = "small";
    ButtonSizes["Medium"] = "medium";
    ButtonSizes["Large"] = "large";
})(ButtonSizes = exports.ButtonSizes || (exports.ButtonSizes = {}));
var ButtonTypeAttributes;
(function (ButtonTypeAttributes) {
    ButtonTypeAttributes["Button"] = "button";
    ButtonTypeAttributes["Submit"] = "submit";
    ButtonTypeAttributes["Reset"] = "reset";
})(ButtonTypeAttributes = exports.ButtonTypeAttributes || (exports.ButtonTypeAttributes = {}));
var GenericButton = (function (_super) {
    __extends(GenericButton, _super);
    function GenericButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GenericButton.prototype.getInitialState = function () {
        return { inClickState: false };
    };
    GenericButton.prototype.handleClick = function (e) {
        var _this = this;
        var _a = this.props, onClick = _a.onClick, data = _a.data;
        if (!onClick || this.state.inClickState) {
            return;
        }
        var callBackResult = (0, isUndefined_1.default)(data) ? onClick() : onClick(data);
        if ((0, isUndefined_1.default)(callBackResult) || !callBackResult.then) {
            return;
        }
        this.setState(function (state) { return ({ inClickState: true }); });
        callBackResult.then(function () {
            _this.setState(function (state) { return ({ inClickState: false }); });
        });
    };
    GenericButton.prototype.renderInternal = function () {
        this.addCssClass("btn-".concat(this.props.buttonShape));
        this.addCssClass("btn-".concat(this.props.buttonSize));
        this.addCssClass("btn-".concat(this.props.buttonType));
        this.addCssClass(this.props.className);
        this.addCssClassIf('in-click-state', this.state.inClickState);
        return (react_1.default.createElement(Button_1.default, { className: this.renderCssClasses(), onClick: this.handleClick.bind(this), bsStyle: null, disabled: this.state.inClickState || this.props.disabled, type: this.props.type, ref: this.forwardRef(this.props.buttonRef) }, this.props.children));
    };
    GenericButton.defaultProps = {
        buttonType: ButtonTypes.Secondary,
        buttonShape: ButtonShapes.Rectangle,
        buttonSize: ButtonSizes.Medium,
        type: ButtonTypeAttributes.Button
    };
    return GenericButton;
}(techsee_base_component_1.TechseeBaseComponent));
exports.GenericButton = GenericButton;

//# sourceMappingURL=index.js.map
